import { render } from "./CreatedProperties.vue?vue&type=template&id=120e2a7a"
import script from "./CreatedProperties.vue?vue&type=script&lang=js"
export * from "./CreatedProperties.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__